<script>
  export let inline = false
</script>

<svg class:inline width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <line x1="7" y1="14" x2="7" stroke="#F8F1D4" stroke-width="1.5"/>
  <line y1="7" x2="14" y2="7" stroke="#F8F1D4" stroke-width="1.5"/>
</svg>

<style lang="scss">
  svg {
    &.inline {
      padding-left: 3px;
      padding-right: 4px;
      height: 1em;
      position: relative;
      top: 0.08em;
    }
  }

</style>